import React, { useMemo } from "react";

import { SelectInput } from "ra-ui-materialui";
import moment from "moment";

const YEARS = [2020, 2021, 2022, 2023, 2024];

const YearSelectInput = (props) => {
  const choices = useMemo(() => {
    const year = parseInt(moment().add(1, "y").format("YYYY"), 10);
    return YEARS.filter((y) => y <= year).map((year) => ({
      name: year,
      id: year,
    }));
  }, []);

  return <SelectInput {...props} choices={choices} />;
};

export default YearSelectInput;
